var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-global header-buttonless"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo-img",attrs:{"alt":"Logo LotePerfecto","src":require('../assets/logo-200.webp')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }